<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="profile-menu-multiple-role-selector">
	<mat-extended-select
		[formControl]="currentRole"
		[option$]="roleList$"
		[labelPath]="['view', 'roleName']"
		[valuePath]="[]"
		[iconBackgroundColorPath]="['view', 'color']"
		[placeholder]="placeHolderRole"
		[sortOptions]="sortAlphabetically"
		(click)="stopPropagation($event)"
	>
	</mat-extended-select>
</div>
